import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import CompanyForm from './CompanyForm';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import CompanySchedule from './CompanySchedule';
import { Button, Tab, Tabs, Grid, Divider, DialogTitle, DialogContent, DialogActions, Dialog } from '@material-ui/core';
import RelationUpdateTabs from '../../components/RelationUpdateTabs';
import StaticRelationList from '../../components/StaticRelationList';
import * as validatorActions from '../../components/validator/store/actions';
import DetailCalendar from '../../components/DetailCalendar';
import TabPanelButtons from '../../components/TabPanelButtons';
import CompanyQualifications from './CompanyQualifications';
import SelfPacedCourses from './SelfPacedCourses';
import CompanyAuthList from './CompanyAuthList';
import PageHeader from 'main/components/PageHeader';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class Company extends Component {
    state = {
        current_tab: 0,
        company_id: 0,
        view_type: '',
        tabValue: 0,
        deleteDialogActive: false
    }

    constructor(props) {
        super(props);

        const company_id = this.props.match.params.company_id;
        const view_type = this.props.match.params.view_type;
        const user_role = this.props.auth.user.data.role_info;

        const paramHistory = this.props.paramHistory;

        if (user_role.role_id === 5) {
            if (company_id != user_role.company_id) {
                this.props.history.push('/profile')
            }
        }
        
        this.state = {
            ...this.state,
            company_id: company_id,
            view_type: view_type,
            current_tab: paramHistory.active ? 4 : 0
        }
        this.props.updateCompanyLoaded(false);
        this.props.getCompanyData(company_id);

        const validationList = [
            {
                field_name: 'CompanyName', functionName: ['checkRequiredFilled']
            },
        ]

        this.props.startValidator(validationList)
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    handleSubmit = () => {
        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.saveCompany(this.props.currentCompany, this.props.relatedInstructorList, this.props.relatedMajorList);
                    this.props.history.push('/company/list');
                    break;
                }
            case ("edit"):
                {
                    this.props.saveCompany(this.props.currentCompany, this.props.relatedInstructorList, this.props.relatedMajorList)
                    this.props.history.push('/company/list');
                    break;
                }
            default:
                { }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true })
    }

    handleDelete = () => {
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.deleteCompany(this.props.currentCompany.company_id);
                    this.props.history.push('/company/list');
                    break;
                }

            default:
                {

                }

        }
    }

    handleMajorSearchChange = (e) => {
        this.setState({
            majorSearch: e.target.value
        })
    }

    getPageContent = (current_tab, view_type) => {
        const { classes, theme, currentCompany, isCompanyLoaded, relatedInstructorList, relatedMajorList, allMajors,
            allCourses, allModules, allLessons, events, dayEvents,
            coursePreviewData, modulePreviewData, selectedEventData, scheduledCourses } = this.props;


        const currentMajorsTab = relatedMajorList.map(m => {
            return (
                { label: m.MajorName, id: m.major_id }
            )
        })

        const addMajorTabData = allMajors.map(m => {
            return (
                { label: m.MajorName, id: m.major_id }
            )
        })

        switch (current_tab) {
            case (0): // Detail
                {
                    return (
                        <CompanyForm
                            view_type={view_type}
                        />
                    )
                }
            case (1): // Relation
                {
                    return (
                        view_type === 'detail' ?
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <StaticRelationList
                                        rootClass={classes.root}
                                        items={currentMajorsTab}
                                        header={'Majors'}
                                    />
                                </Grid>
                            </Grid>
                            :
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <RelationUpdateTabs
                                        currentRelationsTabData={currentMajorsTab}
                                        handleDelete={this.props.toggleMajor}
                                        handleAdd={this.props.toggleMajor}
                                        availableObjectList={addMajorTabData}
                                        handleSearchChange={this.handleMajorSearchChange}
                                        leftHeader="Current Majors"
                                        rightHeader="Available Majors"
                                        classes={classes}
                                        search={this.state.majorSearch}
                                        view_type={this.props.view_type}
                                        rootClass={classes.root}
                                        dir={theme.direction}
                                    />
                                </Grid>
                            </Grid>
                    )
                }
            case (2):
                {
                    if (view_type === 'edit') {
                        return (
                            <CompanySchedule
                                company={currentCompany}
                                events={events}
                                allCourses={allCourses}
                                allModules={allModules}
                                allLessons={allLessons}
                                coursePreviewData={coursePreviewData}
                                modulePreviewData={modulePreviewData}
                                dayEvents={dayEvents}
                                selectedEventData={selectedEventData}
                                view_type={view_type}
                            />
                        )
                    }
                    else {
                        return (
                            <DetailCalendar
                                object_id={currentCompany.company_id}
                                events={events}
                                dayEvents={dayEvents}
                                getSchedule={this.props.getEvents}
                                getDayEvents={this.props.getDayEvents}
                            />
                        )
                    }
                }
            case (3):
                {
                    return (
                        <SelfPacedCourses 
                            courseList={allCourses.filter(course => course.Unscheduled === 1)}
                            company_id={currentCompany.company_id}
                            view_type={view_type}
                        />
                    )
                }
            case (4):
                {
                    return (
                        <CompanyAuthList 
                            company_id={currentCompany.company_id}
                        />
                    )
                }
            default:
                {
                    return <React.Fragment>Error: No tab found.</React.Fragment>
                }
        }
    }

    getDeleteDialog = (active, company) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Delete {company.CompanyName}?</DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Delete
                        </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    disableSave = () => {
        const { validator } = this.props;
        const { view_type } = this.state

        switch (view_type) {
            case ("edit"): {
                return (
                    validator.map(v => v.error)
                        .includes(true)
                )
            }
            case ('create'): {
                return !(
                    validator.every(v => v.error === false)
                )
            }
        }
    };

    render() {
        const { classes, currentCompany, isCompanyLoaded } = this.props;
        // console.log(this.props)
        const { current_tab, view_type } = this.state;
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentCompany)

        if (!isCompanyLoaded) {
            return <div>loading</div>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isCompanyLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }

        const deleteTooltipContent = 
            <React.Fragment>
                <h4>This Company is attached to:</h4>
                <div key={1}>Users: {this.props.deleteInfo.users.length}</div>
                <div key={2}>Courses: {this.props.deleteInfo.courses.length}</div>
                <div key={3}>Events: {this.props.deleteInfo.events.length}</div>
            </React.Fragment>

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <PageHeader
                        component_name = {currentCompany.CompanyName}
                        component_type = {"company"}
                        view_type      = {view_type}
                    />
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        label="Detail"
                                    />
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        label="Relation"
                                    />
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        label="Scheduled Courses"
                                        disabled={view_type === 'create'}
                                    />
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        // label="Non-Calendar Schedule List for Scheduled Unscheduled Courses"
                                        label="Self-Paced Courses"
                                        disabled={view_type === 'create'}
                                    />
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        // label="Non-Calendar Schedule List for Scheduled Unscheduled Courses"
                                        label="Users"
                                        disabled={view_type === 'create'}
                                    />
                                </Tabs>
                                <TabPanelButtons
                                    component_name = {"company"}
                                    view_type      = {view_type}
                                    button_list    = {[
                                        {
                                            display:  "Save",
                                            type:     "update",
                                            onClick:  this.handleSubmit,
                                            disabled: this.disableSave(),
                                        },
                                        {
                                            type:     "delete",
                                            onClick:  this.handleDeleteDialogOpen,
                                            disabled: !this.props.deleteInfo.deleteAllowed,
                                            tooltip:  { active: !this.props.deleteInfo.deleteAllowed, content: deleteTooltipContent },
                                        },
                                        {
                                            type:    "back",
                                            onClick: this.props.history.goBack
                                        }
                                    ]}
                                />
                        </Grid>
                    </div>

                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {delete_dialog}
                            {page_content}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCompany: Actions.getCompany,
        getCompanyData: Actions.getCompanyData,
        updateCompanyLoaded: Actions.updateCompanyLoaded,
        saveCompany: Actions.saveCompany,
        deleteCompany: Actions.deleteCompany,
        toggleInstructor: Actions.toggleInstructor,
        toggleMajor: Actions.toggleMajor,
        updateCompanyForm: Actions.updateCompanyForm,
        startValidator: validatorActions.startValidator,
        getEvents: Actions.getEvents,
        getDayEvents: Actions.getDayEvents,
    }, dispatch)
}

function mapStateToProps({ companyApp, validator, paramHistory, lessonApp, auth }) {
    return {
        currentCompany: companyApp.companies.currentCompany,
        isCompanyLoaded: companyApp.companies.isCompanyLoaded,
        relatedInstructorList: companyApp.companies.relatedInstructorList,
        relatedMajorList: companyApp.companies.relatedMajorList,
        allMajors: companyApp.companies.allMajors,
        allCourses: companyApp.companies.allCourses,
        allModules: companyApp.companies.allModules,
        allLessons: lessonApp.lessons.lessonList,
        currentCompanyCourseList: companyApp.companies.currentCompanyCourseList,
        currentCompanyModuleList: companyApp.companies.currentCompanyModuleList,
        currentCompanyCompanyList: companyApp.companies.currentCompanyCompanyList,
        isCompanyLoaded: companyApp.companies.isCompanyLoaded,
        events: companyApp.companies.events,
        coursePreviewData: companyApp.companies.coursePreviewData,
        modulePreviewData: companyApp.companies.modulePreviewData,
        dayEvents: companyApp.companies.dayEvents,
        selectedEventData: companyApp.companies.selectedEventData,
        scheduledCourses: companyApp.companies.scheduledCourses,
        validator: validator.list,
        paramHistory: paramHistory.companyAuth,
        deleteInfo: companyApp.companies.deleteInfo,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Company)));



// WEBPACK FOOTER //
// src/main/content/company/Company.js